<template>
  <div class="cmp-header">
    <h1>
      <span class="btn-back" @click="back">
        <van-icon name="arrow-left"/>
      </span>
      {{title}}
    </h1>
  </div>
</template>

<script>
import { Icon } from 'vant'
export default {
  components: {
    [Icon.name]: Icon
  },
  name: 'Header',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  methods: {
    back() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
.cmp-header {
  width: 100%;
  height: @headerHeight;
  line-height: @headerHeight;
  // padding-left: 10px;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
  background-color: @primary;
  color: #fff;
  font-size: 16px;
  .btn-back {
    display: inline-block;
    height: 100%;
    padding: 0 10px;
  }
  .van-icon {
    vertical-align: middle;
  }
}
</style>


